/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  GET_CATEGORIES,
  SELECT_CATEGORY,
  SELECT_SET_CATEGORY,
} from '../../constants/actionType'
import category from '../../services/api/category'
import * as _ from 'lodash'
/**
 * Declare Variable
 */
const getCategoriesAction = createAction(GET_CATEGORIES)
const selectCategoryAction = createAction(SELECT_CATEGORY)
const selectSetCategoryAction = createAction(SELECT_SET_CATEGORY)

/**
 * Export
 */
export const getCategories = (merchantId, packages, datetime) => async (dispatch, getState) => {
  try {
    const isTakeaway = getState().basket.isTakeaway
    dispatch(getCategoriesAction(null))
    const categoryList = await category.list(merchantId, isTakeaway, datetime)

    if (_.get(packages, 'length')) {
      const filteredCategoryList = categoryList.filter(category => {
        return packages.some(p => category.id.startsWith(p))
      })
      dispatch(getCategoriesAction(filteredCategoryList))
      return filteredCategoryList
    } else {
      dispatch(getCategoriesAction(categoryList))
    }
    return categoryList
  } catch (error) {
    return Promise.reject(error)
  }
}

export const selectCategory = (category) => async (dispatch) => {
  try {
    dispatch(selectCategoryAction(category))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const selectSetCategory = (subCategory) => async (dispatch) => {
  try {
    dispatch(selectSetCategoryAction(subCategory))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/category.js